/**
 * Vuex persist config
 */
const vuexPersistConfig = {
  /** Key of vuex persisted store in the browser*/
  key: "maropost-admin",

  /**  Browser storage where the vuex store will be persisted */
  storage: window.localStorage,

  /**
   * Vuex store modules to be persisted in the localstorage
   * @todo Add the name of the store modules which are to be persisted in the {modules} array
   */
  modules: ["auth", "settings"],
};

export default vuexPersistConfig;
